<template>
  <div class="header-icon" @click="openAuth">
    <img :src="icon">
    <div class="header-icon-title">{{ label }}</div>

    <div ref="auth" class="nnmodal" style="display:none; width: 100%; max-width:545px; padding: 30px; border-radius: 10px;">
      <login :link-recovery="authConfig.linkRecovery" :link-registration="authConfig.linkRegistration" @success="finish" @error="error"></login>
    </div>

  </div>

  <toast v-if="toast.title && toast.message" :toast="toast"></toast>
</template>

<script>
import {Fancybox} from "@fancyapps/ui";
import Login from "../auth/Login.vue";
import Toast from "../alert/Toast.vue";
import Common from "../../../tool/Common";
import ToastService from "../../../service/ToastService";

export default {
  name: "MenuItem",
  components: {
    Toast,
    Login,
  },
  props: {
    icon: {
      type: String,
      default: null,
    },
    label: {
      type: String,
      default: null,
    },
    authConfig: {
      type: Object,
      default: {},
    },
  },
  data: function () {
    return {
      toast: {
        title: null,
        message: null,
        type: null,
      },
    };
  },
  methods: {
    showErrorToast(title, message) {
      this.toast.type = 'error';
      this.toast.message = message;
      this.toast.title = title;

      // АДСКИЙ КОСТЫЛЬ
      setTimeout(() => {
        this.toast.type = null;
        this.toast.message = null;
        this.toast.title = null;
      }, 3500);
    },
    openAuth() {
      Fancybox.show([{src: this.$refs.auth, type: "inline"}]);
    },
    finish(user) {
      ToastService.addSuccessMessage("Авторизация", "Вы успешно вошли на сайт").then(response => {
        if (response.status === 200) {
          Fancybox.destroy();
          Common.redirect('/');
        }
      });
    },
    error(message) {
      this.showErrorToast("Авторизация", message);
    },
  }
}
</script>

<style scoped>

</style>